import { frameworkIdentifierFormatter } from 'src/identifier';

export const nextJsFormatters = [frameworkIdentifierFormatter];
